(function(){
if(window.__vynAnim2)return;window.__vynAnim2=1;
var d=document,root=d.documentElement;
var SKIP='.vyn-about-grid,.vyn-trust,.vyn-story-image,.vyn-story-card,.vyn-centered,.vyn-value,.vyn-product,.vyn-promise,.vyn-faq-heading,.vyn-faq-group,.vyn-faq-item,.vyn-article';
var GRAN=['.vyn-about-grid > div','.vyn-trust > div','.vyn-story-image','.vyn-story-card','.vyn-centered','.vyn-value','.vyn-product','.vyn-promise','.vyn-faq-heading','.vyn-faq-group','.vyn-faq-item','.vyn-article h2','.vyn-article h3','.vyn-article p','.vyn-article img','.vyn-article table'];
function reveal(){
try{
if(window.matchMedia&&(window.matchMedia('(prefers-reduced-motion: reduce)').matches||window.matchMedia('(max-width: 989px)').matches))return;
root.classList.add('vyn-js');
var els=[];
var main=d.getElementById('MainContent')||d.querySelector('main');
if(main){var secs=main.querySelectorAll(':scope > .shopify-section, :scope > section');for(var i=1;i<secs.length;i++){var s=secs[i];if(!s.querySelector(SKIP)){els.push(s);}}}
GRAN.forEach(function(sel){var n=d.querySelectorAll(sel);for(var j=0;j<n.length;j++){els.push(n[j]);}});
if(!els.length)return;
if(!('IntersectionObserver' in window))return;
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vyn-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -6% 0px',threshold:0.06});
els.forEach(function(n){n.classList.add('vyn-reveal');io.observe(n);});
setTimeout(function(){for(var k=0;k<els.length;k++){els[k].classList.add('vyn-in');}},2600);
}catch(e){try{root.classList.remove('vyn-js');}catch(_){}}
}
if(d.readyState!=='loading')reveal();else d.addEventListener('DOMContentLoaded',reveal);
})();